//CHANGE IMAGE ON INPUT CHANGE ON PRODUCT IMAGES
$(function () {
  $(".product-form__input input[type=radio]").change(function () {
    // console.log($(this));
    changeImage();
  });

  function changeImage() {
    var productJson = $("#product-json");
    var productSlider = $(".product-slider");
    
    if (productJson.length > 0) {
      var string = "";
      var hardcodeImg = "";
      
      $(".product-form__input.fieldset").each(function (index) {
        if (index == 0) {
          hardcodeImg = $(this).find("input:checked").data("img");
          string += $(this).find("input:checked").val();
        } else {
          string += " / " + $(this).find("input:checked").val();
        }
      });
      
      var productVariants = JSON.parse(productJson.html());
      var variant = productVariants.find((item) => item.public_title === string);
      
      $(".product-slider img").each(function (index) {
        var imgSrc = $(this).attr("src");
        if (
          variant.featured_image == null &&
          hardcodeImg != "" &&
          hardcodeImg != null &&
          hardcodeImg.includes(imgSrc)
        ) {
          productSlider.slick("slickGoTo", index);
        }
        if (
          imgSrc != null &&
          variant.featured_image != null &&
          variant.featured_image.src.includes(imgSrc)
        ) {
            // console.log(index);
          productSlider.slick("slickGoTo", index);
        }
      });
    }
  }
  
  changeImage();
});
